import type { Country } from '@/constants/config';
import type { CampaignName } from '@/constants/SE';

export const queryKeys = {
  cms: {
    notices: ['cms', 'notices'],
    privacyPolicy: ['cms', 'privacyPolicy'],
    sekki: ['cms', 'sekki'],
    termsAndConditions: ['cms', 'termsAndConditions'],
  },
  UK: {
    application: (applicationId: string) => ['application', applicationId],
    bankAccount: ['bankAccount'],
    bankAccountStatus: ['bankAccountStatus'],
    documents: (applicationId: string) => ['documents', applicationId] as const,
    creditAmount: ['creditAmount'],
    loqateFind: (text: string, container = '') => ['loqateFind', text, container],
    loqateRetrieve: (id: string) => ['loqateRetrieve', id],
    marketingConsentText: ['marketingConsentText'],
    payment: ['payment'],
    paymentById: (paymentInitiationId: string) => ['paymentById', paymentInitiationId],
    productTierProjection: (productTierId: string, installments: number) => [
      'productTierProjection',
      productTierId,
      installments,
    ],
    directDebit: ['directDebit'],
  },
  SE: {
    bankIdStatus: (orderId: string) => ['bankIdStatus', orderId],
    loginData: (orderId?: string) => ['loginData', orderId ?? ''],
    application: (applicationId?: string) => ['application', applicationId],
    idProtect: ['idProtect'],
    paymentProtectionInsurance: ['paymentProtectionInsurance'],
    loanWithdrawalStatus: ['loanWithdrawalStatus'],
  },
  FI: {
    loginWithSessionId: (sessionId: string) => ['loginWithSessionId', sessionId],
    productTiers: (channelProviderId: string) => ['productTiers', channelProviderId],
    embeddedPartners: (country: Country) => ['embeddedPartners', country],
  },
  overdueInfo: ['overdueInfo'],
  applicant: (applicantId: string) => ['applicant', applicantId],
  bankAccount: ['bankAccount'],
  creditFeatures: ['creditFeatures'],
  debtConsolidationFeatures: ['debtConsolidationFeatures'],
  loanFeatures: ['loanFeatures'],
  directPaymentById: (directPaymentId: string) => ['directPaymentId', directPaymentId],
  directPaymentStatus: (paymentId?: string) =>
    ['directPaymentStatus', ...(paymentId ? [paymentId] : [])] as const,
  financialDetails: ['financialDetails'],
  me: ['me'],
  pendingTransaction: ['pendingTransaction'],
  products: ['products'],
  mobileVerification: ['mobileVerification'],
  usersMe: ['usersMe'],
  offers: ['offers'],
  withdrawalById: (transactionId: string) => ['withdrawalById', transactionId],
  creditActions: ['creditActions'],
  creditTierMigrationInfo: ['creditTierMigrationInfo'],
  promotions: ['promotions'],
  transactions: ['transactions'],
  transactionsNextPayback: ['transactions', 'nextPayback'],
  transactionsCurrentPayback: ['transactions', 'currentPayback'],
  userIdProtect: ['userAddonProducts', 'idProtect'],
  userPaymentProtectionInsurance: ['userAddonProducts', 'paymentProtectionInsurance'],
  userTerminateAccountDetails: ['userTerminateAccountDetails'],
  campaign: (name: CampaignName) => ['campaign', name],
};
